<template>
  <v-form ref="passwordResetForm" @submit.prevent="changeMyPassword">
    <v-container fluid class="password px-2 px-md-0">
      <v-row class="password-content">
        <h2 class="d-none d-md-block">Password</h2>
        <h2 class="d-block d-md-none group-label col-12">Change Password</h2>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Current Password"
                type="password"
                v-model="password.oldPassword"
                :rules="currentPasswordRules"
                flat
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="New Password"
                type="password"
                v-model="password.password"
                :rules="newPasswordRules"
                flat
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Confirm New Password"
                type="password"
                v-model="password.passwordConfirmation"
                :rules="confirmPasswordRules"
                flat
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="mt-5 d-flex justify-end ">
        <v-btn
          :block="$vuetify.breakpoint.mobile"
          color="appRed"
          type="submit"
          class="white--text d-block d-md-inline-block"
          >Save</v-btn
        >
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "PasswordComponent",
  components: {},
  data: () => ({
    password: {},
    currentPasswordRules: [
      v => !!v || "Password is required",
      v => v.length >= 6 || "Password must be at least 6 characters",
      v => v.length <= 15 || "Password must be less than 15 characters"
    ],
    newPasswordRules: [
      v => !!v || "Password is required",
      v => v.length >= 6 || "Password must be at least 6 characters",
      v => v.length <= 15 || "Password must be less than 15 characters"
    ],
    confirmPasswordRules: [
      v => !!v || "Password is required",
      v => v.length >= 6 || "Password must be at least 6 characters",
      v => v.length <= 15 || "Password must be less than 15 characters"
    ]
  }),
  methods: {
    async changeMyPassword() {
      if (this.$refs.passwordResetForm.validate()) {
        this.$swal({
          title: "Change password...",
          html: "this will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store
          .dispatch("auth/CHANGE_PASSWORD", this.password)
          .then(() => {
            this.$swal.close();
            this.$swal({
              title: "Success",
              html: "Password updated successfully",
              icon: "info"
            });
          })
          .catch(err => {
            this.$swal.close();
            this.$swal({
              title: "Failure",
              html: err,
              icon: "error"
            });
          });
        this.showChangePassword = false;
      }
    }
  }
};
</script>
<style lang="scss" src="./Password.scss"></style>
<style lang="scss">
.password-content {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
}


</style>
